export const dummyAlarms = [

    {
        Customer : 'MasMovil',
        ShortDescription : 'Degradation on 3G call attempts Failure rate',
        TTNumber : 'INC000087241181',
        Severity : 'Critical',
        IncidentStatus: 'Open',
        AffectedServices: 'Mobile',
        AffectedCustomers: '50000',
        AffectedNodes: '4G RAN',
        EventStartTime: '01-02-2024 11:15',
        IncidentManager: 'Pablo Rueda',
        UpdateNotification: 'Current impact: TA CS detected degradation on 3G CSSR, due to Talex 124764. Degradation of the 3G call attempts FR from 15% to 50%. Rollback requested to Implementer team to contain impact.'
    },
    {
        Customer : 'MasMovil',
        ShortDescription : 'Degradation on 3G call attempts Failure rate',
        TTNumber : 'INC000087241182',
        Severity : 'Normal',
        IncidentStatus: 'Open',
        AffectedServices: 'Fixed',
        AffectedCustomers: '1000',
        AffectedNodes: 'OLT Paredes',
        EventStartTime: '01-02-2024 12:13',
        IncidentManager: 'Pablo Rueda',
        UpdateNotification: 'Current impact: 250 customer in town Paredes'
    },
    {
        Customer : 'PepePhone',
        ShortDescription : 'Landing Page down',
        TTNumber : 'INC000087241183',
        Severity : 'Critical',
        IncidentStatus: 'Open',
        AffectedServices: 'IT',
        AffectedCustomers: 'New users',
        AffectedNodes: 'Landing Page',
        EventStartTime: '01-02-2024 14:16',
        IncidentManager: 'Catalin Spiridion',
        UpdateNotification: 'Landing Page Pepehone Down'
    },
    {
        Customer : 'MasMovil',
        ShortDescription : 'Degradation on 3G call attempts Failure rate',
        TTNumber : 'INC000087241184',
        Severity : 'Critical',
        IncidentStatus: 'Open',
        AffectedServices: 'Mobile',
        AffectedCustomers: '50000',
        AffectedNodes: '4G RAN',
        EventStartTime: '01-02-2024 11:15',
        IncidentManager: 'Pablo Rueda',
        UpdateNotification: 'Current impact: TA CS detected degradation on 3G CSSR, due to Talex 124764. Degradation of the 3G call attempts FR from 15% to 50%. Rollback requested to Implementer team to contain impact.'
    },
    {
        Customer : 'Yoigo',
        ShortDescription : 'Degradation on 3G call attempts Failure rate',
        TTNumber : 'INC000087241185',
        Severity : 'Critical',
        IncidentStatus: 'Open',
        AffectedServices: 'FTTH',
        AffectedCustomers: '50000',
        AffectedNodes: '4G RAN',
        EventStartTime: '01-02-2024 11:15',
        IncidentManager: 'Pablo Rueda',
        UpdateNotification: 'Current impact: TA CS detected degradation on 3G CSSR, due to Talex 124764. Degradation of the 3G call attempts FR from 15% to 50%. Rollback requested to Implementer team to contain impact.'
    },
    {
        Customer : 'Lebara',
        ShortDescription : 'Degradation on 3G call attempts Failure rate',
        TTNumber : 'INC000087241186',
        Severity : 'Critical',
        IncidentStatus: 'Open',
        AffectedServices: 'Mobile',
        AffectedCustomers: '50000',
        AffectedNodes: '4G RAN',
        EventStartTime: '01-02-2024 11:15',
        IncidentManager: 'Pablo Rueda',
        UpdateNotification: 'Current impact: TA CS detected degradation on 3G CSSR, due to Talex 124764. Degradation of the 3G call attempts FR from 15% to 50%. Rollback requested to Implementer team to contain impact.'
    },
]